module.exports = __webpack_public_path__ + "static/media/stjosephvictoria.372e63c4.webp";